import { injected } from '../../injected-auth';
import { StreamHttpError } from './stream-http';

const STABLE_CONNECTION_MS = 30_000;

export const SSE_PLANNED_CLOSE_CAPABILITY = 'sse_planned_close_v1';

export const withClientCapabilities = (url: string): string =>
  `${url}${url.includes('?') ? '&' : '?'}client_capabilities=${SSE_PLANNED_CLOSE_CAPABILITY}`;

export const isStableConnection = (openedAt: number | null): boolean =>
  openedAt !== null && Date.now() - openedAt >= STABLE_CONNECTION_MS;

export const refreshAuthAfterUnauthorized = async (error: unknown): Promise<boolean> => {
  if (!(error instanceof StreamHttpError) || error.status !== 401) return false;
  try {
    return !!(await injected('getAuthToken')());
  } catch {
    return false;
  }
};
